module.exports = __webpack_public_path__ + "media/categories/1042-cf3aa4ad.svg";